import { render, staticRenderFns } from "./work-package-reveal.vue?vue&type=template&id=5ab38e56&scoped=true"
import script from "./work-package-reveal.vue?vue&type=script&lang=js"
export * from "./work-package-reveal.vue?vue&type=script&lang=js"
import style0 from "./work-package-reveal.vue?vue&type=style&index=0&id=5ab38e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab38e56",
  null
  
)

export default component.exports